export default {
  state: {
    adminOidcConnections: {},
    adminOidcConnectionUsers: {},
    adminLdapConnections: {},
    adminLdapConnectionUsers: {},
    adminSamlConnections: {},
    adminSamlConnectionUsers: {}
  },
  mutations: {
    setAdminOidcConnections(state, payload) {
      state.adminOidcConnections = { ...payload };
    },
    setAdminOidcConnectionUsers(state, payload) {
      state.adminOidcConnectionUsers = { ...payload };
    },
    setAdminLdapConnections(state, payload) {
      state.adminLdapConnections = { ...payload };
    },
    setAdminLdapConnectionUsers(state, payload) {
      state.adminLdapConnectionUsers = { ...payload };
    },
    setAdminSamlConnections(state, payload) {
      state.adminSamlConnections = { ...payload };
    },
    setAdminSamlConnectionUsers(state, payload) {
      state.adminSamlConnectionUsers = { ...payload };
    },
    changeAdminSamlConnectionStatus(state, payload) {
      const itemIndex = state.adminSamlConnections.items.findIndex(
        (item) => item.uuid === payload.uuid
      );

      if (itemIndex !== -1) {
        state.adminSamlConnections.items[itemIndex].enabled = payload.enabled.isEnabled;
      }
    },
    deleteAdminOidcConnection(state, payload) {
      const itemIndex = state.adminOidcConnections.items.findIndex((item) => item.id === payload);

      if (itemIndex !== -1) {
        state.adminOidcConnections.items.splice(itemIndex, 1);
      }
    },
    changeAdminOidcConnectionStatus(state, payload) {
      const itemIndex = state.adminOidcConnections.items.findIndex(
        (item) => item.id === payload.oidcConnectionUuid
      );

      if (itemIndex !== -1) {
        state.adminOidcConnections.items[itemIndex].isEnabled = payload.enabled.isEnabled;
      }
    },
    changeAdminLdapConnectionStatus(state, payload) {
      const itemIndex = state.adminLdapConnections.items.findIndex(
        (item) => item.id === payload.ldapConnectionUuid
      );

      if (itemIndex !== -1) {
        state.adminLdapConnections.items[itemIndex].disabled = payload.enabled.isEnabled;
      }
    }
  },
  actions: {
    setAdminOidcConnections(state, payload) {
      state.commit('setAdminOidcConnections', payload);
    },
    setAdminOidcConnectionUsers(state, payload) {
      state.commit('setAdminOidcConnectionUsers', payload);
    },
    changeAdminOidcConnectionStatus(state, payload) {
      state.commit('changeAdminOidcConnectionStatus', payload);
    },
    setAdminLdapConnections(state, payload) {
      state.commit('setAdminLdapConnections', payload);
    },
    setAdminLdapConnectionUsers(state, payload) {
      state.commit('setAdminLdapConnectionUsers', payload);
    },
    setAdminSamlConnections(state, payload) {
      state.commit('setAdminSamlConnections', payload);
    },
    setAdminSamlConnectionUsers(state, payload) {
      state.commit('setAdminSamlConnectionUsers', payload);
    },
    changeAdminSamlConnectionStatus(state, payload) {
      state.commit('changeAdminSamlConnectionStatus', payload);
    },
    deleteAdminOidcConnection(state, payload) {
      state.commit('deleteAdminOidcConnection', payload);
    },
    changeAdminLdapConnectionStatus(state, payload) {
      state.commit('changeAdminLdapConnectionStatus', payload);
    }
  },
  getters: {
    getAdminOidcConnections(state) {
      return state.adminOidcConnections;
    },
    getAdminOidcConnectionUsers(state) {
      return state.adminOidcConnectionUsers;
    },
    getAdminLdapConnections(state) {
      return state.adminLdapConnections;
    },
    getAdminLdapConnectionUsers(state) {
      return state.adminLdapConnectionUsers;
    },
    getAdminSamlConnections(state) {
      return state.adminSamlConnections;
    },
    getAdminSamlConnectionUsers(state) {
      return state.adminSamlConnectionUsers;
    }
  }
};
